import React, {useEffect} from 'react';
import TwoColumnPageContent from "../../hoc/TwoColumnPageContent/TwoColumnPageContent";
import StateType from "../../store/store";
import {connect, ConnectedProps} from "react-redux";
import PageTitle from "../../components/PageTitle/PageTitle";
import AccountActions from "../../store/actions/AccountActions";
import {Col, Row, Spinner,  Image} from "react-bootstrap";
import { Helmet } from 'react-helmet';

import styles from './TermsOfUse.module.scss';
import UserAccessPage from '../../hoc/UserAccessPage/UserAccessPage';

const map_state_to_props = (state: StateType) => ({
    state: {
        is_admin: state.account.is_admin,
    }
});

const map_dispatch_to_props = (dispatch: any) => ({
    actions: {
        go_home: () => dispatch(AccountActions.go_home())
    }
});

const connector = connect(map_state_to_props, map_dispatch_to_props);

type TermsOfUseProps = ConnectedProps<typeof connector> & {};

const TermsOfUse = ({
                      state: {
                          is_admin,
                      },
                      actions: {
                          go_home,
                      }
                  }: TermsOfUseProps) => {

        const TermsOfUse = () => (
            <div className={styles.section}>
                <h3 className={`fw-bold mb-3`}>Terms Of Use</h3>
                <p className={'mb-3'}>Effective Date: January 24th, 2024.</p>
                <p>
                    The following Terms of Use (these "TOU") outline the terms and conditions applicable to your access and use of the Consent On Demand site,
                    available at <a href={'https://www.consentondemand.com'}>https://www.consentondemand.com</a> (the "Website"). The Website is owned and operated by Big Wave Systems, LLC,
                    a Delaware limited liability company. By using the Website, you are accepting and agreeing to these TOU. By agreeing to these TOU,
                    you are also agreeing to the other policies posted on the Privacy page of the Website, including, but not limited to, the Privacy and 
                    Security Policy. If you do not agree to these TOU, do not use the Website. Consent On Demand reserves the right to modify these TOU
                    and the other policies posted on the Privacy page of the Website at any time without notice. Continued use of the Website will constitute
                    acceptance of such modifications.
                </p>
            </div>
        );

    const UserResponsibilities = () => (
        <li>
            <div className={styles.section}>
                <span className={`fw-bold`}>User Responsibilities:</span>
                <ul style={{ listStyleType: 'disc' }}>
                    <li>By using the Website, you represent that you are at least eighteen (18) years of age and are a resident of the United States. </li>
                    <li>You are responsible for maintaining the confidentiality of your account and password.</li>
                    <li>You agree not to misuse the Service or engage in any activity that may compromise its security.</li>
                    <li>You are granted a nonexclusive, nontransferable, nonsublicensable, terminable license to access and use the Website for your personal use.</li>
                </ul>
            </div>
        </li>
    );

    const ConsentForm = () => (
        <li>
            <div className={styles.section}>
                <span className={`fw-bold`}>Consent Form:</span>
                <ul style={{ listStyleType: 'disc' }}>
                    <li>By electronically signing the consent form provided by Consent On Demand, you acknowledge and agree that your electronic signature constitutes a binding signature. </li>
                </ul>
            </div>
        </li>
    );

    const UserContent = () => (
        <li>
            <div className={styles.section}>
                <span className={`fw-bold`}>User Content:</span>
                <ul style={{ listStyleType: 'disc' }}>
                    <li>You retain ownership of the consent requests you create and manage using the Service.</li>
                    <li>You agree to not access, reproduce, duplicate, copy, sell, re-sell, modify, distribute, transmit or otherwise exploit the Website or any of its content for any purpose
                        except for your personal use and as described in these TOU, without the express written consent of Big Wave Systems LLC.</li>
                </ul>
            </div>
        </li>
    );

    const IntellectualProperty = () => (
        <li>
            <div className={styles.section}>
                <span className={`fw-bold`}>Intellectual Property:</span>
                <ul style={{ listStyleType: 'disc' }}>
                    <li>The Service and its original content, features, and functionality are owned by Big Wave Systems LLC and
                         are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.</li>
                </ul>
            </div>
        </li>
    );

    const Termination = () => (
        <li>
            <div className={styles.section}>
                <span className={`fw-bold`}>Termination:</span>
                <ul style={{ listStyleType: 'disc' }}>
                    <li>Big Wave Systems LLC. reserves the right to terminate or suspend your account at any
                         time without prior notice for violation of these Terms.</li>
                    <li>It is your responsibility to maintain a valid and active form of payment. 
                        Failure to do so will result in the termination of your account upon your renewal Date/Times.</li>
                </ul>
            </div>
        </li>
    );

    const Disclaimer = () => (
        <li>
            <div className={styles.section}>
                <span className={`fw-bold`}>Disclaimer:</span>
                <ul style={{ listStyleType: 'disc' }}>
                    <li>The software is provided "as is" without any warranties, express or implied.</li>
                    <li>The software may be subject to interruptions, errors, or security vulnerabilities, and we do not warrant that it will be error-free or uninterrupted.</li>
                    <li>Users are responsible for the security of their accounts, passwords, and the data they input into the software.</li>
                    <li>We are not liable for any damages, losses, or expenses arising from the use or inability to use the software.</li>
                    <li>We reserve the right to modify, suspend, or discontinue the software at any time without prior notice.</li>
                </ul>
            </div>
        </li>
    );

    const GoverningLaw = () => (
        <li>
            <div className={styles.section}>
                <span className={`fw-bold`}>Governing Law:</span>
                <ul style={{ listStyleType: 'disc' }}>
                    <li>These Terms are governed by and construed in accordance with the laws of [Your Jurisdiction].</li>
                </ul>
            </div>
        </li>
    );


    return (
        <Col xs={12}>
            <Row className={'mt-4 mt-md-4 d-flex justify-content-center'}>
                <Col xs={12} md={{span: 5}} lg={{span: 3}} >
                    <Image src={'/images/Consent-On-Demand-logo-CMYK-300.jpg'}
                        alt={'Consent on Demand Logo'}
                        fluid
                        className={'w-100 me-auto ms-auto'}/>
                </Col>
            </Row>
            <Col className={`${styles.Disclosure} mt-3`}>
                <Col xs={12} lg={{span: 12}} className={'mb-5 mb-sm-0'}>

                    <Row>
                        <TermsOfUse />
                        <ol style={{ paddingLeft: '5rem' }}>
                            <UserResponsibilities />
                            <ConsentForm />
                            <UserContent />
                            <IntellectualProperty />
                            <Termination />
                            <Disclaimer />
                            <GoverningLaw />
                        </ol>
                    </Row>
                </Col>
            </Col>
        </Col>
    );
};

export default connector(TermsOfUse);
